<template>
  <LayoutDefault>
    <section class="accessible-environment">
      <h1 class="accessible-environment__title">Доступная среда</h1>
      <div class="accessible-environment__content">
        <AccessibleEnvironmentTable :data="dataSource" />
        <table class="accessible-environment__categories-table">
          <thead>
            <tr>
              <th class="accessible-environment__table-title">Категория</th>
              <th class="accessible-environment__table-title">Наполнение</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, idx) in categoriesTest"
              :key="idx"
            >
              <td class="accessible-environment__categories">
                <p>{{ item.name }}</p>
              </td>
              <td class="accessible-environment__filling">
                <Textarea
                  v-model="item.description"
                  autoResize
                  rows="1"
                  cols="70"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </LayoutDefault>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import LayoutDefault from '@/layout/LayoutDefault'
import AccessibleEnvironmentTable from '@/components/blocks/AccessibleEnvironmentTable.vue'

import Textarea from 'primevue/textarea'

export default {
  name: 'AccessibleEnvironmentView',
  components: {
    LayoutDefault,
    AccessibleEnvironmentTable,
    Textarea
  },
  props: {
  },
  setup () {
    const store = useStore()

    const dataSource = computed(() => {
      // данные для отрисовки таблицы
      return store.getters.getNewsDataTable
    })

    const categoriesTest = ref([
      {
        id: 1,
        name: 'об обеспечении беспрепятственного доступа в здания образовательной организации',
        description: 'Для обеспечения возможности беспрепятственного доступа один из входов в здание оборудован табличкой желтого цвета, а другой кнопкой вызова со звонком. Входная группа оборудована предупреждающим желтым кругом («Жёлтый круг для слабовидящих»), обеспечивающим контрастную маркировку дверного проема. Конструктивные особенности здания располагают расширенными коридорами и дверными проемами, отсутствуют пороги и перепады уровней полового покрытия в помещениях.'
      },
      {
        id: 2,
        name: 'об электронных образовательных ресурсах, к которым обеспечивается доступ инвалидов и лиц с ограниченными возможностями здоровья',
        description: 'Собственные электронные образовательные ресурсы: лекционные материалы, практические материалы, электронные учебники, электронные книги; оценочные материалы для процедур текущего контроля успеваемости, промежуточной и итоговой аттестации, интернет-портал с имеющий интерфейс с увеличенными шрифтами. Доступ к учебным и учебно-методическим материалам осуществляется через систему «Moodle» и по электронной почте. Сторонние электронные образовательные и информационные ресурсы: Министерство науки и высшего образования Российской Федерации (https://minobrnauki.gov.ru/); Министерство просвещения Российской Федерации (https://edu.gov.ru/); Федеральный портал «Российское образование» (http://www.edu.ru/); Информационная система «Единое окно доступа к образовательным ресурсам» (http://window.edu.ru/); Единая коллекция цифровых образовательных ресурсов (http://school-collection.edu.ru/); Федеральный центр информационно-образовательных ресурсов (http://fcior.edu.ru/).'
      }
    ])

    return {
      dataSource,
      categoriesTest
    }
  }
}
</script>

<style lang="scss" scoped>
.accessible-environment {
  &__title {
    @include information-block-title;
    margin-bottom: 24px;
  }

  &__content {
    width: 60%;
  }

  &__categories-table {
    text-align: left;

    tr {
      vertical-align: top;
    }
  }

  &__table-title {
    font-size: 18px;
    font-weight: 500;
    padding-bottom: 8px;
  }

  &__categories {
    p {
      font-size: 14px;
      line-height: 18px;
    }
  }

  &__filling {
    :deep(.p-inputtextarea) {
      margin-bottom: 10px;
      padding: 8px 12px;
      font-size: 14px;
      line-height: 18px;
    }
  }

  :deep(.accessible-table) {
    margin-bottom: 125px;
  }
}
</style>
